import { Box, LinearProgress, Typography } from "@mui/material";

export default function LoaderLinearProgress() {
  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
      <LinearProgress />
      <Typography variant="body2" color="text.secondary">
        Cargando...
      </Typography>
    </Box>
  )
}
